import config from "../../store/sqftConfig";

export default new function() {
	var settings = {
			orientation: "vertical",
			range: "min",
			min: 1,
			max: 10,
			value: null,//config.scale,
			step: 1,
			slide: function( event, ui ) {
				config.scale = ui.value;
				config.controls.scale.slider("value", ui.value);
				config.controls.scaleHoriz.slider("value", ui.value);
			}
		};
	this.init = function() {
		settings.value = config.scale;
    settings.orientation = "horizontal";
    // todo sqft-react
		//config.controls.scale.slider(settings);
		//config.controls.scaleHoriz.slider(settings);
		this.setMouseWheel();
	};
	this.setMouseWheel = () => {
		this.delta = 0;
		const elem = document.getElementById("workspace");
		if (elem.addEventListener) {
			if ('onwheel' in document) {
				// IE9+, FF17+, Ch31+
				elem.addEventListener("wheel", this.onWheel);
			} else if ('onmousewheel' in document) {
				// устаревший вариант события
				elem.addEventListener("mousewheel", this.onWheel);
			} else {
				// Firefox < 17
				elem.addEventListener("MozMousePixelScroll", this.onWheel);
			}
		} else { // IE8-
			elem.attachEvent("onmousewheel", this.onWheel);
		}
	};
	this.onWheel = (e) => {
		e = e || window.event;
		// wheelDelta не даёт возможность узнать количество пикселей
		var delta = e.deltaY || e.detail || e.wheelDelta;
		// var info = document.getElementById('delta');
		const deltaDiff = +this.delta + delta;
		//console.log("deltaDiff", deltaDiff);
		(deltaDiff > this.delta) ? this.scaleMinus() : this.scalePlus();
		e.preventDefault ? e.preventDefault() : (e.returnValue = false);
	};
	this.scalePlus = () => {
		config.scale += 0.15;
		if (config.scale > 12) {
			config.scale = 12;
		}
	};
	this.scaleMinus = () => {
		config.scale -= 0.15;
		if (config.scale < 0.75) {
			config.scale = 0.75;
		}
	};
};
